import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import Primer from '../views/Primer.vue'
import Apply from '../views/Apply.vue'
import Clusters from '../views/Clusters.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },

  {
    path: '/primer',
    name: 'Primer',
    component: Primer
  },

  {
    path: '/apply',
    name: 'Apply',
    component: Apply
  },

  {
    path: '/cluster-primer',
    name: 'Clusters',
    component: Clusters,
    props: true,
  }
]

const router = new VueRouter({
  routes
})

export default router
